module.exports = __webpack_public_path__ + "static/media/Login-screen-main-img.d710af87.png";